"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DELIVERY_STATUS = exports.DRAW_STATUS = void 0;
// ─── Flash Sale: Draw ───────────────────────────────────────
/** 抽奖结果状态 */
exports.DRAW_STATUS = {
    /** 待开奖 */
    PENDING: 0,
    /** 已中奖 */
    WON: 1,
    /** 未中奖 */
    LOST: 2,
    /** 失败 */
    FAILED: 3,
};
/** 消息投递状态 */
exports.DELIVERY_STATUS = {
    /** 待投递 */
    PENDING: 0,
    /**
     * 已投递（处理中）。
     *
     * Server 端采用 logpipe SDK 上报事件；根据 logpipe 文档，SDK 调用无异常即表示事件已写入
     * 本机 `/data/log/logpipe_sdk/logpipe_sdk.log`，后续由 logpipe_agent 异步上传到中台 Kafka。
     * 因此这里的“已投递”口径是“已进入 logpipe 本地可靠投递链路”，不是消费端已处理完成。
     */
    DELIVERED: 1,
};
